// eslint-disable-next-line import/prefer-default-export
export const ClearApiErrorAction = 'app/CLEAR_API_ERROR';

export const clearApiError = name => ({
  type: ClearApiErrorAction,
  name,
});
